"use client";
export const ForgotYourUma = () => {
  return <></>;
};
